<script>
    import axios from "axios";
    export default {

        data() {
            return {
                isDisabled:false,

                compname:'',
                    compnameSeen:false,

                roc:'',
                    rocSeen:false,

                organization:'',
                    organizationSeen:false,

                address:'',
                    addressSeen:false,

                PIC:'',
                    PICSeen:false,

                contactnumber:'',
                    contactnumberSeen:false,

                useremail:'',
                    useremailSeen:false,

                password:'',
                    passwordSeen:false,

                confirmpassword:'',
                    confirmpasswordSeen:false,
                    passwordNotSame:false,

                country:'',
                    countrySeen:false,

                Accept:false,
                    AcceptSeen:false,

                oldNum:0,

                ReffrelStatus:false,
                referaluseremail:'',

                ResultMsk:'false',
                ResultMskSuccess:false,
                ResultMskfail:false,
                OrgData:[],
                loadingOrg:true,
                loading:false,

                
                isSeenCountry:true,
                countryList:[],

                tncURL: '',
                privacyURL: '',
            }
            
        },
        

        methods: {
            SignUp(){  
                this.loading=true;
                this.ReffrelStatus=false;

                // if(this.referaluseremail != ''){
                //     this.CheckReffral();
                // }

                // if(this.ReffrelStatus==false){

                    var checerrortrue = 1;
                    if(this.compname){
                        this.compnameSeen=false;
                    }else{
                        this.compnameSeen=true;
                        checerrortrue = checerrortrue *0;
                    }

                    if(this.roc){
                        this.rocSeen=false;
                    }else{
                        this.rocSeen=true;
                        checerrortrue = checerrortrue *0;
                    }

                    if(this.organization){
                        this.organizationSeen=false;
                    }else{
                        this.organizationSeen=true;
                        checerrortrue = checerrortrue *0;
                    }

                    if(this.address){
                        this.addressSeen=false;
                    }else{
                        this.addressSeen=true;
                        checerrortrue = checerrortrue *0;
                    }

                    if(this.PIC){
                        this.PICSeen=false;
                    }else{
                        this.PICSeen=true;
                        checerrortrue = checerrortrue *0;
                    }

                    if(this.contactnumber){
                        this.contactnumberSeen=false;
                    }else{
                        this.contactnumberSeen=true;
                        checerrortrue = checerrortrue *0;
                    }

                    if(this.useremail){
                        this.useremailSeen=false;
                        if (!this.validEmail(this.useremail)) {
                            this.useremailSeen=true;
                            checerrortrue = checerrortrue *0;
                        }

                    }else{
                        this.useremailSeen=true;
                        checerrortrue = checerrortrue *0;
                    }

                    if(this.password){
                        this.passwordSeen=false;
                    }else{
                        this.passwordSeen=true;
                        checerrortrue = checerrortrue *0;
                    }

                    if(this.confirmpassword){
                        this.confirmpasswordSeen=false;
                    }else{
                        this.confirmpasswordSeen=true;
                        checerrortrue = checerrortrue *0;
                    }

                    if(this.country){
                        this.countrySeen=false;
                    }else{
                        this.countrySeen=true;
                        checerrortrue = checerrortrue *0;
                    }

                    if(this.Accept == true){
                        this.AcceptSeen=false;
                    }else{
                        this.AcceptSeen=true;
                        checerrortrue = checerrortrue *0;
                    }

                    if(this.password != this.confirmpassword){

                        // console.log(this.password);
                        // console.log('------');
                        // console.log(this.confirmpassword);
                        this.passwordNotSame = true;
                        checerrortrue = checerrortrue *0;
                    }else{
                        this.passwordNotSame = false;
                    }

                    if(checerrortrue == 1){
                        // /user/create/customer
                        if(typeof  this.$route.query.country !== 'undefined'){
                            this.country = this.$route.query.country;
                        }
                        const posting_ = { 
                            password: this.password, 
                            confirmpassword: this.confirmpassword, 
                            PIC: this.PIC, 
                            useremail: this.useremail, 
                            contactnumber: this.contactnumber, 
                            compname: this.compname, 
                            roc: this.roc, 
                            address: this.address, 
                            organization: this.organization,
                            country: this.country,
                            referralemail: this.referaluseremail,
                        };
                        axios.post(process.env.VUE_APP_API_BASEURL+'user/create/customer/', posting_)
                        .then(response => {
    
                            if (response.data.msj) {
                                this.ResultMsk = response.data.msj;
                                this.ResultMskSuccess=true;
                                setTimeout(() => this.loading = false, 500);
                            }else{
                                this.ResultMsk = 'Error.';
                                this.ResultMskfail=true;
                                setTimeout(() => this.loading = false, 500);
                            }
                        }).catch(error => {
                                this.messageBag = [error.error];
                                setTimeout(() => this.loading = false, 500);
                        });
                        
                    }
                    

            },

            GetCountry(){
                axios.get(process.env.VUE_APP_API_BASEURL+'country')
                .then(response => {
                // console.log('xxxxxxx');
                    if (response) {
                        if(response.data.status=='error'){
                            // console.log('aaaaaaaaaa');
                            this.messageBag = response.data.msj;
                            this.countreload = true;
                        }else{
                            // console.log(response.data);
                            this.countryList = response.data;
                            this.countreload = true;
                            
                        }
                        
                    } else {
                        // console.log('daddddd');
                        this.messageBag = ['No record.'];
                        this.countreload = true;
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                        this.countreload = true;
                });
            },

            changeLocation(e) {
            if(e.target.value != ""){
                this.country_ = e.target.value;
                this.tncURL = process.env.VUE_APP_LANDING+'/'+this.country_+'.php?tnc=1';
                this.privacyURL = process.env.VUE_APP_LANDING+'/'+this.country_+'.php?privacy=1';
            }else{
                this.tncURL = process.env.VUE_APP_LANDING+'/sg.php?tnc=1';
                this.privacyURL = process.env.VUE_APP_LANDING+'/sg.php?privacy=1';
            }
        },

            NumbersOnly(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
        
            
            validEmail: function (email) {
                var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            
            organizationList(){
                axios.get(process.env.VUE_APP_API_BASEURL+'organization/list')
                .then(response => {
                    if (response) {
                        this.OrgData = response.data;
                        // console.log(this.OrgData);
                        this.loadingOrg=false;
                    } else {
                        this.messageBag = ['No record.'];
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                });
            },

            // CheckReffral(){
            //     this.ReffrelStatus=false;
            //     axios.get(process.env.VUE_APP_API_BASEURL+'reffral/'+this.referaluseremail)
            //     .then(response => {
            //         if(response.data == true){
            //             this.ReffrelStatus=false;
            //         }else{
            //             this.ReffrelStatus=true; //email not found 
            //         }
                    
            //     })
            //         .catch(error => {
            //             this.messageBag = [error.error];
            //     });
            // }

        },

        mounted() {
            

            if(typeof  this.$route.query.country !== 'undefined'){
                this.country = this.$route.query.country;
                this.isSeenCountry=false;
            }

            if(typeof  this.country !== 'undefined'){
                this.country_='sg';
            }else{
                this.country_=this.country;
            }
            this.tncURL = process.env.VUE_APP_LANDING+'/'+this.country_+'.php?tnc=1';
            this.privacyURL = process.env.VUE_APP_LANDING+'/'+this.country_+'.php?privacy=1';

            this.organizationList();
            this.GetCountry();
            
            var password = document.getElementById("password-input")
            password.onchange = this.validatePassword;
            document.querySelectorAll("form .auth-pass-inputgroup")
                .forEach(function (item) {
                    item.querySelectorAll(".password-addon").forEach(function (subitem) {
                        subitem.addEventListener("click", function () {
                            var passwordInput = item.querySelector(".password-input");
                            if (passwordInput.type === "password") {
                                passwordInput.type = "text";
                            } else {
                                passwordInput.type = "password";
                            }
                        });
                    });
                });



            // var compname = document.getElementById("compname");
            // var roc = document.getElementById("roc");
            // var organization = document.getElementById("organization");
            // var address = document.getElementById("address");
            // var PIC = document.getElementById("PIC");
            // var contactnumber = document.getElementById("contactnumber");
            // var address = document.getElementById("address");
            // var address = document.getElementById("address");
            // var address = document.getElementById("address");


            var myInput = document.getElementById("password-input");
            var letter = document.getElementById("pass-lower");
            var capital = document.getElementById("pass-upper");
            var number = document.getElementById("pass-number");
            var length = document.getElementById("pass-length");

            // When the user clicks on the password field, show the message box
            myInput.onfocus = function () {
                document.getElementById("password-contain").style.display = "block";
            };

            // When the user clicks outside of the password field, hide the password-contain box
            myInput.onblur = function () {
                document.getElementById("password-contain").style.display = "none";
            };

            // When the user starts to type something inside the password field
            myInput.onkeyup = function () {
                // Validate lowercase letters
                var lowerCaseLetters = /[a-z]/g;
                if (myInput.value.match(lowerCaseLetters)) {
                    letter.classList.remove("invalid");
                    letter.classList.add("valid");
                } else {
                    letter.classList.remove("valid");
                    letter.classList.add("invalid");
                }

                // Validate capital letters
                var upperCaseLetters = /[A-Z]/g;
                if (myInput.value.match(upperCaseLetters)) {
                    capital.classList.remove("invalid");
                    capital.classList.add("valid");
                } else {
                    capital.classList.remove("valid");
                    capital.classList.add("invalid");
                }

                // Validate numbers
                var numbers = /[0-9]/g;
                if (myInput.value.match(numbers)) {
                    number.classList.remove("invalid");
                    number.classList.add("valid");
                } else {
                    number.classList.remove("valid");
                    number.classList.add("invalid");
                }

                // Validate length
                if (myInput.value.length >= 8) {
                    length.classList.remove("invalid");
                    length.classList.add("valid");
                } else {
                    length.classList.remove("valid");
                    length.classList.add("invalid");
                }
            };
        },

    }
</script>

<template>
    <!-- auth-page wrapper -->
    <div class="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100" style="background: linear-gradient(-45deg, #ffffff 50%, #5bbbae); padding-top: 0rem !important; padding-bottom: 0rem">
        <div class="bg-overlay"></div>
        <!-- auth-page content -->
        <div class="auth-page-content overflow-hidden pt-lg-5" style="padding-top: 0rem !important; padding-bottom: 0px;">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card overflow-hidden m-0">
                            <div class="row justify-content-center g-0">

                                <div class="col-lg-4">
                                    <div class="p-lg-5 p-4 auth-one-bg h-100">
                                        <div class="bg-overlay"></div>
                                        <div class="position-relative h-100 d-flex flex-column">
                                            <div class="mb-4">
                                                <router-link to="/" class="d-block">
                                                    <img src="@/assets/images/logo-light.png" alt="" height="60">
                                                </router-link>
                                                <br><br><br><br>
                                                <div class="row" v-if="country != 'US'">
                                                    <div class="col-lg-6">
                                                        <div class="text-center">
                                                            <p class="fs-15 fst-italic text-white-50">" For less than 6 devices, please scan the above QR code to download our InstaCash app in Playstore(for Android) or App Store (for iOS) "</p>
                                                            
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-6">
                                                        <br>
                                                        <img src="@/assets/images/qr.png" height='70%'>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-auto">
                                                <div class="mb-3">
                                                    <!-- <i class="ri-double-quotes-l display-4 text-success"></i> -->
                                                </div>

                                                <div id="qoutescarouselIndicators" class="carousel slide"
                                                    data-bs-ride="carousel">
                                                    <!-- <div class="carousel-indicators">
                                                        <button type="button" data-bs-target="#qoutescarouselIndicators"
                                                            data-bs-slide-to="0" class="active" aria-current="true"
                                                            aria-label="Slide 1"></button>
                                                        <button type="button" data-bs-target="#qoutescarouselIndicators"
                                                            data-bs-slide-to="1" aria-label="Slide 2"></button>
                                                        <button type="button" data-bs-target="#qoutescarouselIndicators"
                                                            data-bs-slide-to="2" aria-label="Slide 3"></button>
                                                    </div>
                                                    <div class="carousel-inner text-center text-white-50 pb-5">
                                                        <div class="carousel-item active">
                                                            <p class="fs-15 fst-italic">" For less than 6 devices, please scan the above QR code to download our InstaCash app in Playstore(for Android) or App Store (for iOS) "</p>
                                                        </div>
                                                        <div class="carousel-item">
                                                            <p class="fs-15 fst-italic">" The theme is really great with
                                                                an amazing customer support."</p>
                                                        </div>
                                                        <div class="carousel-item">
                                                            <p class="fs-15 fst-italic">" Great! Clean code, clean
                                                                design, easy for customization. Thanks very much! "</p>
                                                        </div>
                                                    </div> -->
                                                </div>
                                                <!-- end carousel -->

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-8">
                                    <div class="p-lg-5 p-4">
                                        <div>
                                            <h5 class="text-primary">Register Account</h5>
                                            <p class="text-muted">Get your Free account now.</p>
                                        </div>

                                        <div class="mt-4">
                                            <!-- novalidate -->
                                            <form @submit.prevent="SignUp" class="needs-validation">
                                                <div class="row">
                                                    
                                                    <div class="col-lg-6">
                                                        
                                                        <div class="mb-3">
                                                            <label for="compname" class="form-label">Company Name<span class="text-danger">*</span></label>
                                                            <input v-model="compname" type="text" class="form-control" id="compname" placeholder="Enter Company Name">
                                                            <div class="invalid-feedback">
                                                                Please Enter Company Name
                                                            </div>
                                                            <p class="text-danger" v-if='compnameSeen'>
                                                                Please Enter Company Name
                                                            </p>
                                                        </div>

                                                        <div class="mb-3">
                                                            <div v-if="country == 'US'" >
                                                                <label for="roc" class="form-label">
                                                                    Company EIN or Company Tax ID<span class="text-danger">*</span></label>
                                                                    <input v-model="roc" type="text" class="form-control" id="roc" placeholder="Enter Company EIN or Company Tax ID" >
                                                                
                                                            </div>
                                                            <div v-else>
                                                                <label for="roc" class="form-label">
                                                                    Company Registration No.<span class="text-danger">*</span></label>
                                                                <input v-model="roc" type="text" class="form-control" id="roc" placeholder="Enter Company Registration Number" >
                                                            </div>
                                                            
                                                            <div class="invalid-feedback">
                                                                Please Enter Company Registration Number
                                                            </div>
                                                            <p class="text-danger" v-if='rocSeen'>
                                                                Please Enter Company Registration Number
                                                            </p>
                                                        </div>


                                                        

                                                        <div class="mb-3" v-if="loadingOrg">
                                                            <div class="spinner-border text-success" role="status">
                                                                <span class="sr-only">Loading...</span>
                                                            </div>
                                                        </div>
                                                        <div class="mb-3" v-else>
                                                            <label for="organization" class="form-label">Organization Size<span class="text-danger">*</span></label>
                                                            <select v-model="organization" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Type of Organization">
                                                                <option value="">Please Select Organization Size</option>
                                                                <option v-for="(item, index) in OrgData" :key="index" :value="item.id" >
                                                                    {{ item.name }}
                                                                </option>
                                                            </select>
                                                            <div class="invalid-feedback">
                                                                Please Enter Organization Size
                                                            </div>
                                                            <p class="text-danger" v-if='organizationSeen'>
                                                                Please Enter Organization Size
                                                            </p>
                                                        </div>

                                                        <div class="mb-3">
                                                            <label for="address" class="form-label">Company Address<span class="text-danger">*</span></label>
                                                            <textarea v-model="address" rows="6" class="form-control" id="address" placeholder="Enter Company Address" style="height:125px"></textarea>
                                                            <div class="invalid-feedback">
                                                                Please Enter Company Address
                                                            </div>
                                                            <p class="text-danger" v-if='addressSeen'>
                                                                Please Enter Company Address
                                                            </p>
                                                        </div>

                                                        <div class="mb-3" v-if="isSeenCountry">
                                                            <label for="address" class="form-label">Country<span class="text-danger">*</span></label>
                                                            <div>
                                                                <select v-model="country" @change="changeLocation($event)" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country">
                                                                    <option value="" >Please select country</option>
                                                                    <option v-for="(item, index) in countryList" :key="index" :value="item.code" >
                                                                        {{ item.country }}
                                                                    </option>
                                                                </select>
                                                                <span class="text-danger" v-if='countrySeen'>
                                                                    Please Select Country
                                                                </span>
                                                            </div>
                                                        </div>

                                                        
                                                    </div>

                                                    <div class="col-lg-6">

                                                        <div class="mb-3">
                                                            <label for="PIC" class="form-label">Contact Person <span
                                                                    class="text-danger">*</span></label>
                                                            <input v-model="PIC" type="text" class="form-control" id="PIC"
                                                                placeholder="Enter Contact Person " >
                                                            <div class="invalid-feedback">
                                                                Please Enter Contact Person 
                                                            </div>
                                                            <p class="text-danger" v-if='PICSeen'>
                                                                Please Enter Contact Person 
                                                            </p>
                                                        </div>

                                                        <div class="mb-3">
                                                            <label for="contactnumber" class="form-label">Contact Number <span
                                                                    class="text-danger">*</span></label>
                                                            <input v-model="contactnumber" type="text" class="form-control" id="contactnumber"
                                                                placeholder="Please enter phone number" v-on:keypress="NumbersOnly">
                                                            <div class="invalid-feedback">
                                                                Please Enter Contact Name 
                                                            </div>
                                                            <p class="text-danger" v-if='contactnumberSeen'>
                                                                Please Enter Contact Number 
                                                            </p>
                                                        </div>
                                                        
                                                        <div class="mb-3">
                                                            <label for="useremail" class="form-label">Email <span
                                                                    class="text-danger">*</span><small class="text-muted">Email will be used as Username</small></label>
                                                            <input v-model="useremail" type="email" class="form-control" id="useremail" placeholder="Enter email address" @blur="validateEmail">
                                                            <div class="invalid-feedback">
                                                                Please Enter Email
                                                            </div>
                                                            <p class="text-danger" v-if='useremailSeen'>
                                                                Please Enter Email
                                                            </p>
                                                        </div>
                                                        <!-- <div class="mb-3">
                                                            <label for="username" class="form-label">Username <span
                                                                    class="text-danger">*</span></label>
                                                            <input type="text" class="form-control" id="username"
                                                                placeholder="Enter username" required>
                                                            <div class="invalid-feedback">
                                                                Please enter username
                                                            </div>
                                                        </div> -->

                                                        <div class="mb-3">
                                                            <label class="form-label" for="password-input">Password
                                                                <span class="text-danger">*</span></label>
                                                            <div class="position-relative auth-pass-inputgroup">
                                                                <input v-model="password" type="password" class="form-control pe-5 password-input"
                                                                    onpaste="return false" placeholder="Enter password"
                                                                    id="password-input" aria-describedby="passwordInput"
                                                                    pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" >
                                                                <!-- <button
                                                                    class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                                                                    type="button" id="password-addon"><i
                                                                        class="ri-eye-fill align-middle"></i></button> -->
                                                                <div class="invalid-feedback">
                                                                    Please Enter Password
                                                                </div>
                                                                <p class="text-danger" v-if='passwordSeen'>
                                                                    Please Enter Password
                                                                </p>
                                                            </div>
                                                        </div>
 
                                                        <div class="mb-4">
                                                        </div>
                                                        <div id="password-contain" class="p-3 bg-light mb-2 rounded">
                                                            <h5 class="fs-13">Password must contain: </h5>
                                                            <p id="pass-length" class="invalid fs-12 mb-2">Minimum <b>8
                                                                    characters</b>
                                                            </p>
                                                            <p id="pass-lower" class="invalid fs-12 mb-2">At least <b>one lowercase</b>
                                                                letter
                                                                (a-z)</p>
                                                            <p id="pass-upper" class="invalid fs-12 mb-2">At least
                                                                <b>one uppercase</b>
                                                                letter (A-Z)</p>
                                                            <p id="pass-number" class="invalid fs-12 mb-0">At least <b>one number</b>
                                                                (0-9)
                                                            </p>
                                                        </div>

                                                        <div class="mb-3">
                                                            <label class="form-label" for="confirm-password-input">Confirm Password<span class="text-danger">*</span></label>
                                                            <div class="position-relative auth-pass-inputgroup">
                                                                <input v-model="confirmpassword" type="password" class="form-control pe-5 confirm-password-input" placeholder="Enter Confirm Password" id="confirm-password-input">
                                                                <div class="invalid-feedback">
                                                                    Please Enter Confirm Password
                                                                </div>
                                                                <p class="text-danger" v-if='confirmpasswordSeen'>
                                                                    Please Enter Confirm Password
                                                                </p>
                                                                 <p class="text-danger" v-if='passwordNotSame'>
                                                                    Confirm Password not same as password
                                                                </p>
                                                                
                                                            </div>
                                                        </div>

                                                        <div class="mb-3">
                                                            <label for="useremail" class="form-label">Referral Email </label>
                                                            <input v-model="referaluseremail" type="email" class="form-control" id="referaluseremail" placeholder="Enter referral  email address">
                                                            <div class="invalid-feedback">
                                                                PleReferral Email Not Valid
                                                            </div>
                                                            <p class="text-danger" v-if='ReffrelStatus'>
                                                                Referral Email Not Exist
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-12">
                                                        <input type="checkbox" class="form-check-input ms-0" id="accept" v-model="Accept"  required/>
                                                        I hereby agree to abide by the terms and conditions as provided in the CompAsia microsite 
                                                        <a :href="tncURL" target="_block">Terms and Conditions</a>
                                                        &nbsp;|&nbsp; 
                                                        <a :href="privacyURL" target="_block">Privacy Policy</a>
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <div v-if="ResultMsk == 'Account failed to be created'">
                                                            <div class="alert alert-danger" role="alert">
                                                                <strong>{{ ResultMsk }}</strong>  
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <div class="alert alert-success" v-if='ResultMskSuccess' role="alert">
                                                                <strong>{{ ResultMsk }}</strong>  
                                                            </div>
                                                        </div>

                                                        <div class="alert alert-danger" v-if='ResultMskfail' role="alert">
                                                            <strong>{{ ResultMsk }}</strong>  
                                                        </div>
                                                        <br>
                                                        <span v-if=loading >
                                                            <div class="spinner-border text-success" role="status">
                                                                <span class="sr-only">Loading...</span>
                                                            </div>
                                                        </span>
                                                        <span v-else>
                                                            <button class="btn btn-success w-100" type="submit" v-if="ResultMskSuccess == false || ResultMsk == 'Account failed to be created'">Sign Up</button>
                                                        </span>
                                                        <button class="btn btn-success w-100" type="submit" :disabled='isDisabled' v-if='ResultMsk==false'>Sign Up</button>
                                                        
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <div class="mt-4">
                                                            
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-4">
                                                    </div>
                                                </div>
                                            </form>
                                        </div>

                                        <div class="mt-5 text-center">
                                            <p class="mb-0">Already have an account ? <router-link
                                                    to="/login"
                                                    class="fw-semibold text-primary text-decoration-underline"> Sign In
                                                </router-link>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- end card -->
                    </div>
                    <!-- end col -->

                </div>
                <!-- end row -->
            </div>
            <!-- end container -->
        </div>
        <!-- end auth page content -->

        <!-- footer -->
        <footer class="footer">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="text-center">
                            <!-- <p class="mb-0">&copy; {{new Date().getFullYear()}} Velzon. Crafted with <i class="mdi mdi-heart text-danger"></i> by Themesbrand</p> -->
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <!-- end Footer -->
    </div>
    <!-- end auth-page-wrapper -->
</template>